import React, {useEffect, useRef, useState} from 'react';
import "./Uploader.scss";
import {BsImage} from "react-icons/bs";
import {FaUserAlt} from "react-icons/fa";
import classNames from "classnames";
import {useAuthorizedFileUrl} from "../../helpers/hooks/useAuthorizedFileUrl";

const Uploader = (props: {
    onChange?: (e: any)=>void,
    progress?: {loaded: number, total: number},
    type?:"avatar"| "image",
    disabled?: boolean,
    value?: string,
    style?: any,
}) => {
    const {onChange, progress, type="image", disabled, value = "", style = {}} = props;
    const inputRef:any = useRef();
    const [localBg, setLocalBg] = useState("");
    const authorizedBg = useAuthorizedFileUrl(value);
    const bg = localBg || authorizedBg;

    useEffect(()=>{
        setLocalBg("");
    }, [value]);

    const classes = classNames("uploader", {
        "disabled": disabled
    });

    return (
        <div className={classes} style={style} onClick={()=>{
            inputRef.current.click();
        }}>
            {bg && <img alt="" src={bg}/> || (type === "image"? <BsImage/> : <FaUserAlt/> )}
            <input
                onChange={(e)=>{
                    // @ts-ignore
                    setLocalBg(URL.createObjectURL(e.target.files[0]));
                    // @ts-ignore
                   if(onChange) onChange(e.target.files[0]);

                   inputRef.current.value = [];
                }}
            ref={inputRef}
            type={"file"}
            accept={"image/*"}
            />
            {progress && progress.loaded < progress.total && <div className="progress-bar" style={{width: (progress.loaded / progress.total) * 100 + "%"}}></div> || null}
        </div>
    );
};

export default Uploader;
